/* eslint-disable no-mixed-operators */
import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Modal from '@material-ui/core/Modal'
import ConstructionsMemberForm from './ConstructionsMemberForm'
import useBuildingsApi from '../../hooks/buildings/useBuildingsApi'
import useConstructionStore from '../../stores/ConstructionStore'
import { useHistory } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import ConstructionsImportForm from './ConstructionsImportForm'
import useDebounce from '../../hooks/useDebounce'
import useFormStyles from '../common/FormFields/FormFieldsStyle'
import CustomTable from '../customTable/CustomTable'

import Button from '@material-ui/core/Button'
import ListHeader from '../common/ListHeader'
import { formatCI } from '../common/ShowImageTable'
export default function ConstructionsDetail() {
  let { id } = useParams()

  const classes = useStyles()
  const formClasses = useFormStyles()
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [modalOpen, setModalOpen] = useState(false)
  const [loadModalOpen, setLoadModalOpen] = useState(false)

  const state = useConstructionStore((state) => state)
  const getConstructions = state.fetchConstructions
  const getConstructionById = state.fetchConstructionById

  useEffect(() => {
    const getDetailData = async () => {
      await getConstructionById(id)
    }
    getDetailData()
  }, [id])

  const [{ buildingsState }, { getBuildings }] = useBuildingsApi()
  const history = useHistory()
  const columns = [
    { id: 'name', label: 'Nombre', minWidth: 170 },
    {
      id: 'ci',
      label: 'Documento de identidad',
      minWidth: 170,
      format: (value) => formatCI(value.ci),
    },
    {
      id: 'apartmentId',
      label: 'Lote',
      minWidth: 170,
      format: (value) => value?.apartment?.name || '-',
    },
    {
      id: 'createdAt',
      label: 'Fecha Agregado',
      minWidth: 170,
      format: (value) => new Date(value.createdAt).toLocaleString('es'),
    },
    { id: '', label: '', minWidth: 5 },
  ]

  useEffect(() => {
    const fetchData = async () => {
      getBuildings()
    }
    fetchData()
  }, [])

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  const constructions = state?.constructionById?.constructionMembers || []

  // Calculate the start and end indexes for pagination
  const startIndex = page * rowsPerPage
  const endIndex = startIndex + rowsPerPage

  // Get the paginated constructions
  const paginatedConstructions = constructions.slice(startIndex, endIndex)

  const options = (item) => [
    {
      key: 'delete',
      label: 'Eliminar',
      onClick: () => {
        state.deleteConstructionMember(id, item.id)
      },
    },
  ]

  const onSearchChangeDebounced = useDebounce((value) => {
    getConstructionById(id, { search: value })
  }, 600)

  return (
    <>
      <div className={classes.title}>
        <ListHeader
          smallTitle="Obras"
          bigTitle={`${state.constructionById?.name} (${state.constructionById?.building?.name})`}
          canCreate={true}
          createText="Nueva persona"
          createRedirect={() => setModalOpen(true)}
          goBack={() => history.push('/obras')}
        />
        <h3>{state.constructionById?.description}</h3>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '15px',
          }}
        >
          <h3>
            Fecha de inicio:{' '}
            {new Date(state.constructionById?.date).toLocaleDateString('es')}
          </h3>
          <Button
            variant="contained"
            onClick={() => setLoadModalOpen(true)}
            className={formClasses.primaryButton}
          >
            Cargar Personas
          </Button>
        </div>
      </div>
      <CustomTable
        loading={state.isLoading}
        columns={columns}
        data={constructions || []}
        getData={(params) => getConstructions({ ...params })}
        buildingFilter={false}
        building={false}
        apartmentFilter={false}
        searchTitle={'Nombre, apellido o documento de identidad'}
        searchPlaceholder={
          'Ingrese un nombre, apellido o documento de identidad'
        }
        serverPagination={false}
        serverCount={state?.count}
        options={options}
        handleFiltersChange={(params) => onSearchChangeDebounced(params.search)}
      ></CustomTable>
      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="simple-modal-title"
      >
        <ConstructionsMemberForm
          closeModal={() => setModalOpen(false)}
          handleCancel={() => setModalOpen(false)}
          building={state?.constructionById?.building}
        />
      </Modal>
      <Modal
        open={loadModalOpen}
        onClose={() => setLoadModalOpen(false)}
        aria-labelledby="simple-modal-title"
      >
        <ConstructionsImportForm
          closeModal={() => setLoadModalOpen(false)}
          handleCancel={() => setLoadModalOpen(false)}
          building={state?.constructionById?.building}
        />
      </Modal>
    </>
  )
}

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  addButton: {
    position: 'absolute',
    right: '32px',
    bottom: '32px',
  },
  checkbox: {
    marginLeft: '8px',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  searchWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '20px',
  },
  title: {
    textAlign: 'left',
  },
})
